window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.pokerCashLigaRepo = function () {

    var url = 'api/PokerCashLigaPobjednici';

    var list = function () {
        return fetch(url)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        list: list
    };

}();